const PROFESSION = [
  {
    name: '初级会计职称',
    id: '1',
    course: [
      {
        name: '初级会计实务',
        id: '1',
      },
      {
        name: '经济法基础',
        id: '2',
      },
    ],
  },
  {
    name: '中级会计职称',
    id: '2',
    course: [
      {
        name: '中级会计实务',
        id: '3',
      },
      {
        name: '经济法',
        id: '4',
      },
      {
        name: '财务管理',
        id: '5',
      },
    ],
  },
  {
    name: '注册会计师',
    id: '3',
    course: [],
  },
  {
    name: '管理会计',
    id: '4',
    course: [],
  },
  {
    name: '会计实操',
    id: '5',
    course: [],
  },
  {
    name: '顺带过税务师',
    id: '6',
    course: [],
  },
];

// 课程
const COURSE = {
  1: '初级会计实务',
  2: '经济法基础',
  3: '中级会计实务',
  4: '中级经济法',
  5: '财务管理',
  6: '会计',
  7: '税法',
  8: '经济法',
  9: '财务成本管理',
  10: '审计',
  11: '公司战略和风险管理',
  12: '管理会计概述',
  13: '管理会计职业道德',
  14: '预算实务',
  15: '成本管理',
  16: '工业实操',
};

export { PROFESSION, COURSE };
